import { IntroCard } from './intro-card.model';

/** Tarjetas del Intro, en el orden del deck. Sin Angular. */
export function introCards(): IntroCard[] {
  return [
    {
      key: 'clm',
      title: 'CLM - contratos y firma',
      description: 'Plantillas de documentos; firma electrónica, archivo y alertas.',
      icon: 'docs',
      faIcon: 'fa-solid fa-file-signature',
      link: '/flows/contratos?suite=clm',
    },
    {
      key: 'multiprocesos',
      title: 'Multiprocesos',
      description: 'Oficios, reclamos y solicitudes de industria regulada, automatizados. Contratos, Compliance.',
      icon: 'flows',
      faIcon: 'fa-solid fa-diagram-project',
      link: '/flows/requirements?suite=oficios',
      flowsBadge: true,
    },
    {
      key: 'juicios',
      title: 'Gestión de juicios',
      description: 'Litigios, provisiones y ahorros, con informes y análisis con IA.',
      icon: 'judicial-power',
      faIcon: 'fa-solid fa-scale-balanced',
      link: '/flows/requirements?suite=juicios',
      flowsBadge: true,
    },
    {
      key: 'solicitudes',
      title: 'Solicitudes',
      description: 'Tareas del área legal, con seguimiento por etapa.',
      icon: 'flows',
      faIcon: 'fa-solid fa-clipboard-list',
      link: '/flows/requirements?suite=solicitudes',
      flowsBadge: true,
    },
    {
      key: 'firma',
      title: 'Firma electrónica',
      description: 'Firma simple y avanzada en México, Chile, Perú y Colombia.',
      icon: 'clauses',
      faIcon: 'fa-solid fa-pen-nib',
      link: '/inprovider-sign?tab=firmas',
    },
    {
      key: 'legal-analytics',
      title: 'Legal Analytics',
      description: 'KPIs del área legal en reportes continuos para el negocio.',
      icon: 'legal-analytics',
      faIcon: 'fa-solid fa-chart-column',
      link: '/legal-analytics',
    },
    {
      key: 'conexiones',
      title: 'Conexiones Chile / México',
      description: 'Google Drive; CMF SEIL; SERNAC, PJUD.',
      icon: 'supervisor',
      faIcon: 'fa-solid fa-plug',
      disabled: true,
    },
  ];
}
